import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ArrowDownIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='arrow-down'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M12 3.75L12 20.25'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.75 13.5L12 20.25L5.25 13.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowDownIcon;
